var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRainIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "fjkacmms3a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.662745 0 0 0 0 0.670588 0 0 0 0 0.674510 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#fjkacmms3a)",
    transform: "translate(-401 -1270) translate(172 1270) translate(230)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#E36510",
    strokeWidth: 2,
    d: "M34.222 19.111h-28c.864-7.014 6.8-12.444 13.996-12.444 7.196 0 13.131 5.43 14.004 12.444zM20.444 19.111v14.18c0 1.251.995 2.265 2.223 2.265 1.227 0 2.222-1.014 2.222-2.265v-1.197M20 6.667L20 4.889"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRainIcon);
export default __webpack_public_path__ + "static/media/rain-icon.c8e84e4290bfcb7f037b9612149e13c2.svg";
export { ForwardRef as ReactComponent };